export const portalData = {
    // Fax Details
    hasFax: false,
    faxNo: "",
    
    // Whatsapp details
    hasWhatsApp: true,
    whatsAppNo: "091 750 31304",
    whatsAppNoHolderName: "REGINALD REYES",
    hasAltWhatsApp: false,
    altWhatsAppNo: "",
    altWhatsAppNoHolderName: "",
    hasAltWhatsApp1: false,
    altWhatsAppNo1: "",
    altWhatsAppNoHolderName1: "",
    hasAltWhatsApp2: false,
    altWhatsAppNo2: "",
    altWhatsAppNoHolderName2: false,
    
    // Phone number details
    hasPhoneNo: true,
    phoneNo: "09175031304",
    hasAltPhoneNo: true,
    altPhoneNo: true,
    
    // Telephone number details
    hasTellNo: true,
    tellNo: "091 750 31304",
    tellNoHolderName: "REGINALD REYES",
    hasAltTellNo: true,
    altTellNo: "092 713 35970",
    altTellNoHolderName: "BEHNAZ NIARAKI ASLI",
    hasAltTellNo2: false,
    altTellNo2: "",
    altTellNoHolderName2: "",
    
    // Portal information details
    portalNameXSpace: "Silver Reef Dive Resort",
    portalName: "Silver Reef Dive Resort",
    portalFullName: "Silver Reef Dive Resort Sdn Bhd",
    portalFullNameUppercase: "SILVER REEF DIVE RESORT SDN BHD",
    portalShortAddress: "22KM MAAYUNTUBIG SILVER REEF DIVE RESORT DAUIN NEGROS ORIENTAL",
    portalAddress: "22KM MAAYUNTUBIG SILVER REEF DIVE RESORT DAUIN NEGROS ORIENTAL",
    portalAddressFirstPart: "22KM MAAYUNTUBIG SILVER REEF DIVE RESORT DAUIN NEGROS ORIENTAL",
    portalAddressSecondPart: "",
    portalAddressDetails: "22KM MAAYUNTUBIG SILVER REEF DIVE RESORT DAUIN NEGROS ORIENTAL",
    hasPortalRegNo: false,
    portalRegNo: "",
    
    // Portal Bank Details
    portalBankName: "BANCO DE ORO",
    portalBankAddress: "DUMAGUETE",
    portalBankAccHolderName: "DAUIN SILVER REEF DIVE RESORT,inc",
    portalBankAccNo: "003408012311",
    hasPortalBankSwiftCode: true,
    portalBankSwiftCode: "BNORPHMMXXX",
     
    portalEmail: "srdr.fo@gamil.com",
    portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,   
    appName: "Island Resort Centralised Reservation Platform",

    // GST details
    hasGst: false,
    gstNo: true,
     
    // Website
    portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
   
    // Travoxis Website
    travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
   
    // Facebook page link
    facebookMessengerLink: "https://www.facebook.com/",
   
    // portal S3 base url
    s3AwsUrl: "",
   
    adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,
  
    // Portal Jetty names
    jettyOne: "",
    jettyTwo: "",
    jettyThree: "",
    jettyOneToTwoTime: "",
    jettyTwoToOneTime: ""
}  